import { CartProductDto } from './cartProduct.dto';
import { OrderNoteOptionDto } from './orderNoteOption.dto';

export class TableAddProductRequestDto {
  cartProducts: CartProductDto[];
  orderNoteOptions: OrderNoteOptionDto[];
  operatorEmployeeId?: number;
  printCartProducts?: boolean;
}
